import { render } from "./RatingStar.vue?vue&type=template&id=0e2a4c4a"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__